import { homeworkCountText } from "../../../lib/plurals.ts";

/**
 * Кнопка «Задать» и то, что стоит вплотную к ней: предупреждение про
 * незаконченную раздачу и отказ «на всех» (5.7 docs/homework-phase2-design.md).
 *
 * ⚠️ Кнопка называет число: «Задать 12 работ». Одному ученику она называется
 * «Задать домашнюю»: «Задать 1 работу» читается как машинный текст ровно там,
 * где чаще всего и жмут.
 */
export function AssignActions(props: {
  /** Сколько работ создастся: столько же, сколько выбрано учеников. */
  total: number;
  disabled: boolean;
  busy: boolean;
  progress: number;
  targets: number;
  /** Хвост «заданий: 3 из 5» есть только у заготовки: у тем свой счётчик. */
  counter: string | null;
  /** Раздача не доведена до конца: сказать надо ДО нажатия, а не после. */
  unfinished: boolean;
  allFailure: string | null;
  /** Почему кнопка сейчас недоступна, если причина не видна рядом с ней. */
  note?: string | null;
  onSubmit: () => void;
}) {
  return (
    <>
      {props.unfinished && (
        <p className="muted">
          Домашка задана не всем: чтобы задать остальным, нажмите «Повторить для
          оставшихся» ниже. «Задать» задаст ещё по одной домашке всем отмеченным.
        </p>
      )}

      {props.note != null && <p className="muted">{props.note}</p>}

      <p className="acts">
        {/* Единственная акцентная кнопка формы: ради неё сюда и приходят */}
        <button className="btn btn--primary" disabled={props.disabled} onClick={props.onSubmit}>
          {props.busy
            ? `Задаём… ${props.progress} из ${props.targets}`
            : props.total > 1
              ? `Задать ${homeworkCountText(props.total)}`
              : "Задать домашку"}
        </button>
        {props.counter !== null && <span className="muted">{props.counter}</span>}
      </p>

      {/*
        ⚠️ Отказ «на всех» выглядит ИНАЧЕ, чем пофамильный: одна строка вместо
        двенадцати одинаковых, и выбор учеников при нём не трогается
      */}
      {props.allFailure !== null && (
        <p className="err">Домашка не задана никому: {props.allFailure}</p>
      )}
    </>
  );
}
